const colorIcons = {
  cyan: '#3aa19a',
  red: '#db4040',
  black: '#000000',
  gray: '#474747',
  blue: '#3483FA',
  white: '#FFFFFF',
  grayBorder: '#EDEDED',
  greenAndes: '#00A650',
  grayAndes: '#C4C4C4',
  orangeAndes: '#FF7733',
  // Basic colors
  andesWhite: '#fff',
  andesBlack: '#000',
  // Translucent Grays
  andesGray900: 'rgba(#000, 0.9)', // primary text
  andesGray550: 'rgba(#000, 0.55)', // secondary text
  andesGray250: 'rgba(#000, 0.25)', // disabled text
  andesGray100: 'rgba(#000, 0.1)',
  andesGray070: 'rgba(#000, 0.07)',
  andesGray040: 'rgba(#000, 0.04)',
  // Solid Grays
  andesGray900Solid: '#1A1A1A', // primary text
  andesGray550Solid: '#737373', // secondary text
  andesGray250Solid: '#BFBFBF', // disabled text
  andesGray100Solid: '#E5E5E5',
  andesGray070Solid: '#EDEDED',
  andesGray040Solid: '#F5F5F5',
  // Green
  andesGreen100: 'rgba(0, 166, 80, 0.1)',
  andesGreen150: 'rgba(0, 166, 80, 0.15)',
  andesGreen200: 'rgba(0, 166, 80, 0.2)',
  andesGreen300: 'rgba(0, 166, 80, 0.3)',
  andesGreen400: 'rgba(0, 166, 80, 0.4)',
  andesGreen500: '#00A650',
  andesGreen600: '#008744',
  andesGreen700: '#006633',
  andesGreen800: '#004D27',
  // Orange
  andesOrange100: 'rgba(255, 119, 51, 0.1)',
  andesOrange150: 'rgba(255, 119, 51, 0.15)',
  andesOrange200: 'rgba(255, 119, 51, 0.2)',
  andesOrange300: 'rgba(255, 119, 51, 0.3)',
  andesOrange400: 'rgba(255, 119, 51, 0.4)',
  andesOrange500: '#FF7733',
  andesOrange600: '#E6540B',
  andesOrange700: '#CC3E0A',
  andesOrange800: '#A62A08',
  // Red
  andesRed100: 'rgba(242, 61, 79, 0.1)',
  andesRed150: 'rgba(242, 61, 79, 0.15)',
  andesRed200: 'rgba(242, 61, 79, 0.2)',
  andesRed300: 'rgba(242, 61, 79, 0.3)',
  andesRed400: 'rgba(242, 61, 79, 0.4)',
  andesRed500: '#F23D4F ',
  andesRed600: '#D12440',
  andesRed700: '#A61D33',
  andesRed800: '#801627',
  // Yellow
  andesYellow500: '#FFE600',
  // Base theme ('mercadolibre')
  andesBlueBase: 'rgb(65, 137, 230)',
  andesBlue100: 'rgba($andes-blue-base, 0.1) !default',
  andesBlue150: 'rgba($andes-blue-base, 0.15) !default',
  andesBlue200: 'rgba($andes-blue-base, 0.2) !default',
  andesBlue300: 'rgba($andes-blue-base, 0.3) !default',
  andesBlue400: 'rgba($andes-blue-base, 0.4) !default',
  andesBlue500: '#3483FA',
  andesBlue600: '#2968C8',
  andesBlue700: '#1F4E96',
  andesBlue800: '#183C73',
  // Color Positive
  andesSuccessGreen: '$andes-green-500',
  andesSuccessGreenSecondary: '$andes-green-600',
  // Color Caution
  andesWarningOrange: '$andes-orange-500',
  andesWarningOrangeSecondary: '$andes-orange-600',
  // Color Negative
  andesErrorRed: '$andes-red-500',
  andesErrorRedSecondary: '$andes-red-600',
};

export default colorIcons;
